module.exports = __webpack_public_path__ + "static/media/37-8.2f44fef8.mp3";